import { subjects } from 'src/utils/constants';

import { LessonSubject } from 'src/types/lesson.types';

export const getSubjectInfo = (subject: LessonSubject) => {
  return subjects[subject];
};
